// components/onboarding/TrainerOnboardingWelcomeModal.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTrainerOnboarding } from '../../context/TrainerOnboardingContext';
import { FiArrowRight, FiX, FiCompass } from 'react-icons/fi';
import { MdRocketLaunch } from 'react-icons/md';
import '../../styles/Onboarding.css';

/**
 * TrainerOnboardingWelcomeModal
 *
 * Initial modal shown to first-time trainer users. Points them toward
 * the Setup Checklist on the dashboard as the primary action, with
 * the guided tour as a secondary "Explore features" option.
 */
const TrainerOnboardingWelcomeModal = () => {
    const { showWelcomeModal, startOnboarding, skipOnboarding } = useTrainerOnboarding();
    const { t } = useTranslation('onboarding');

    if (!showWelcomeModal) {
        return null;
    }

    return (
        <div className="onboarding-modal-overlay">
            <div className="onboarding-welcome-modal">
                {/* Close button */}
                <button
                    className="onboarding-close-btn"
                    onClick={skipOnboarding}
                    title={t('trainerWelcome.close')}
                    aria-label={t('trainerWelcome.close')}
                >
                    <FiX />
                </button>

                {/* Header */}
                <div className="onboarding-welcome-header">
                    <div className="onboarding-welcome-icon">
                        <MdRocketLaunch />
                    </div>
                    <h2>{t('trainerWelcome.title')}</h2>
                    <p className="onboarding-welcome-subtitle">
                        {t('trainerWelcome.subtitle')}
                    </p>
                </div>

                {/* Body */}
                <div className="onboarding-welcome-body">
                    <p className="onboarding-welcome-message">
                        {t('trainerWelcome.message')}
                    </p>

                    <div className="onboarding-features-preview">
                        <h4>{t('trainerWelcome.configTitle')}</h4>
                        <ul>
                            <li>
                                <span className="feature-icon"><MdRocketLaunch /></span>
                                <span>{t('trainerWelcome.workingHours')}</span>
                            </li>
                            <li>
                                <span className="feature-icon"><MdRocketLaunch /></span>
                                <span>{t('trainerWelcome.trainingRooms')}</span>
                            </li>
                            <li>
                                <span className="feature-icon"><MdRocketLaunch /></span>
                                <span>{t('trainerWelcome.services')}</span>
                            </li>
                            <li>
                                <span className="feature-icon"><MdRocketLaunch /></span>
                                <span>{t('trainerWelcome.unlockMonths')}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Actions */}
                <div className="onboarding-welcome-actions">
                    <button
                        className="onboarding-btn onboarding-btn-primary"
                        onClick={skipOnboarding}
                    >
                        {t('trainerWelcome.goToConfig')}
                        <FiArrowRight />
                    </button>
                    <button
                        className="onboarding-btn onboarding-btn-secondary"
                        onClick={startOnboarding}
                    >
                        <FiCompass />
                        {t('trainerWelcome.exploreFeatures')}
                    </button>
                </div>

                {/* Footer note */}
                <p className="onboarding-welcome-footer">
                    {t('trainerWelcome.footerNote')}
                </p>
            </div>
        </div>
    );
};

export default TrainerOnboardingWelcomeModal;
